import React from 'react';
import { FormattedMessage } from 'react-intl';
import { LanguageCode } from '@alltrails/shared/utils/languageSupport';
import useLanguageCode from 'hooks/useLanguageCode';
import useFormatMessage from 'hooks/useFormatMessage';
import { MEDIA_QUERY_MOBILE_DOWN } from 'utils/constants/breakpoints';
import * as styles from './styles/styles.module.scss';
import CultureStat from './CultureStat';
import OUR_CULTURE_STRINGS from './ourCulture.strings';

const OurCulture = (): JSX.Element => {
  const {
    formattedDefaultMessages: {
      TEN_K_REASONS,
      THREE_HUNDRED_K,
      CURATED_TRAILS,
      THIRTY_FIVE_MIL,
      FELLOW_EXPLORERS,
      ONE,
      GLOBAL_COMMUNITY,
      BEACH_PHOTO_ALT
    }
  } = useFormatMessage(OUR_CULTURE_STRINGS);
  const languageCode = useLanguageCode();
  const showVideo = languageCode === LanguageCode.English;
  return (
    <div className={styles.container}>
      <div className={styles.embedFlex}>
        <div className={showVideo ? styles.embedContainer : styles.imageContainer}>
          {showVideo ? (
            <iframe
              title={TEN_K_REASONS}
              src="https://player.vimeo.com/video/548955974?h=0d541fd038&color=428A13&title=0&byline=0&portrait=0"
              className={styles.embedVid}
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <picture className={styles.image}>
              <source
                media={MEDIA_QUERY_MOBILE_DOWN}
                srcSet={require('../../../../assets/images/about/10k-reasons-banner-686w.jpg')}
                type="image/jpg"
              />
              <source
                media={MEDIA_QUERY_MOBILE_DOWN}
                srcSet={require('../../../../assets/images/about/10k-reasons-banner-686w.avif')}
                type="image/avif"
              />
              <source
                media={MEDIA_QUERY_MOBILE_DOWN}
                srcSet={require('../../../../assets/images/about/10k-reasons-banner-686w.webp')}
                type="image/webp"
              />
              <source srcSet={require('../../../../assets/images/about/10k-reasons-banner.avif')} type="image/avif" />
              <source srcSet={require('../../../../assets/images/about/10k-reasons-banner.webp')} type="image/webp" />
              <img
                src={require('../../../../assets/images/about/10k-reasons-banner.jpg')}
                alt={BEACH_PHOTO_ALT}
                className={styles.placeholderImage}
                loading="lazy"
              />
            </picture>
          )}
        </div>
      </div>
      <script src="https://player.vimeo.com/api/player.js"></script>
      <div className={styles.textContent}>
        <h2 className={styles.header}>{TEN_K_REASONS}</h2>
        <div className={styles.desc}>
          <FormattedMessage defaultMessage="The more we grow, the more we realize all the ways that nature connects us: to ourselves, to the past, to the ecosystems we live within, and to each other. Here’s to more trails and more community members with even more reasons to get outside." />
        </div>
        <div className={styles.divider} />
        <div className={styles.statsContainer}>
          <CultureStat title={THREE_HUNDRED_K} subtitle={CURATED_TRAILS} />
          <CultureStat title={THIRTY_FIVE_MIL} subtitle={FELLOW_EXPLORERS} />
          <CultureStat title={ONE} subtitle={GLOBAL_COMMUNITY} />
        </div>
      </div>
    </div>
  );
};

export default OurCulture;
